import '@splidejs/splide/dist/css/splide.min.css';

import Map from '@components/Map/MapLanding';
import MicroModal from 'micromodal';
import React from 'react';
import ReactDOM from 'react-dom';
import Splide from '@splidejs/splide';


function launchModal(videoId) {
  MicroModal.show(`modal-video`, {
    onShow: (modal) => {
      modal.querySelector(
        '.Modal-content'
      ).innerHTML = `<iframe src="https://www.youtube.com/embed/${videoId}?controls=0&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    },
    onClose: (modal) => {
      modal.querySelector('.Modal-content').innerHTML = '';
    },
    disableScroll: true
  });
}

const directVideoPlay = [...document.querySelectorAll('[data-play-video]')];

if (directVideoPlay) {
  for (const btnplay of directVideoPlay) {
    btnplay.addEventListener('click', () => {
      if (btnplay.dataset.playVideo) {
        launchModal(btnplay.dataset.playVideo);
      }
    });
  }
}

const slider = document.querySelector('.LandingVideo-videos');
const slideNb =
  (slider && slider.querySelectorAll('.splide__slide').length) || 0;

if (slider) {
  const splide = new Splide(slider, {
    padding: '120px',
    gap: '1rem',
    pagination: false,
    arrows: false,
    type: slideNb > 2 ? 'loop' : 'slide',
    breakpoints: {
      1280: {
        padding: '30px'
      }
    }
  }).mount();

  for (const thumb of [...slider.querySelectorAll('[data-index]')]) {
    thumb.addEventListener('click', () => {
      if (thumb.dataset.index === undefined || !thumb.dataset.video) {
        return;
      }
      const thumbIndex = parseInt(thumb.dataset.index);
      if (typeof thumbIndex === 'number' && thumbIndex !== splide.index) {
        splide.go(thumb.dataset.index);
      } else if (thumbIndex === splide.index) {
        const videoModal = document.getElementById(`modal-video`);
        if (!videoModal) {
          return;
        }

        launchModal(thumb.dataset.video);
      }
    });
  }
}

const mapNode = document.querySelector('.tryout-results-map');

if (mapNode) {
  ReactDOM.render(
    <Map
      category={mapNode.dataset.tryoutCategory || null}
      mainColor={mapNode.dataset.tryoutBackground}
      seasons={
        mapNode.dataset.tryoutSeason
          ? JSON.parse(mapNode.dataset.tryoutSeason)
          : []
      }
    />,
    mapNode
  );
}
